export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Curated%20fashion%20lifestyle%20photography%20featuring%20a%20mix%20of%20premium%20clothing%20pieces%20accessories%20and%20sneakers%20beautifully%20arranged%20on%20a%20light%20cream%20colored%20minimal%20surface%2C%20soft%20diffused%20window%20light%20from%20the%20left%20creating%20gentle%20shadows%20across%20the%20scene%2C%20warm%20neutral%20color%20palette%20with%20sage%20green%20and%20warm%20terracotta%20accents%20throughout%2C%20editorial%20styling%20with%20organic%20placement%20of%20folded%20garments%20a%20leather%20watch%20and%20designer%20sunglasses%2C%20airy%20aspirational%20atmosphere%20with%20subtle%20texture%20details%20and%20refined%20composition%20perfect%20for%20a%20fashion%20resource%20website%20hero%20background&width=1800&height=900&seq=hero-v2-fresh-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion finds and shopping inspiration"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <i className="ri-sparkling-line text-accent-400 text-sm"></i>
            <span className="text-xs md:text-sm text-background-50 font-medium">
              Updated 2026 &bull; Trusted Resource
            </span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            Sugargoo Spreadsheet
            <br />
            <span className="text-accent-300">Find The Best Products, Deals &amp; Shopping Resources</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Access carefully organized Sugargoo spreadsheets, product collections, shopping guides and expert resources to discover better products faster. Your gateway to smarter Sugargoo shopping.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Sugargoo Spreadsheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-semibold hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line group-hover:translate-x-0.5 transition-transform"></i>
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
            {[
              { icon: "ri-checkbox-circle-line", text: "Updated Resources" },
              { icon: "ri-user-heart-line", text: "Beginner Friendly" },
              { icon: "ri-book-open-line", text: "Complete Guides" },
              { icon: "ri-shield-check-line", text: "Safe Shopping Info" },
            ].map((badge) => (
              <div key={badge.text} className="flex items-center gap-2 text-background-50/70 text-sm">
                <i className={`${badge.icon} text-accent-400 text-base`}></i>
                <span className="whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}